import * as crudInterface from './crudInterface/crud';
import functionalInterface from './functionalInterface/call';
import fetch from './fetch/fetch';
import { login, resolveToken } from './auth/auth';
import crudOperations from './crudInterface/operations';
import crudFeatures from './crudInterface/features';
import useCRUD from './crudInterface/useCRUD';
import useFunctional from './functionalInterface/useFunctional';
import { watcherSaga } from './saga/rootSaga';
import * as crudActions from './saga/actions/crud';
import * as functionalActions from './saga/actions/funtional';
import useCrudReadOperation from './crudInterface/useCrudReadOperation';
import usePrevious from './usePrevious/usePrevious';
import useSocket from './socket/useSocket';
import usePermissionCheck from './permissions/usePermissionCheck';
export const crud = {
    interface: crudInterface,
    Operations: crudOperations,
    Features: crudFeatures,
    use: useCRUD,
    actions: crudActions,
    useRead: useCrudReadOperation,
};
export const functional = {
    interface: functionalInterface,
    actions: functionalActions,
    use: useFunctional,
};
export const socket = {
    use: useSocket,
};
export const auth = {
    login,
    resolveToken,
};
export { 
// GLOBAL
usePrevious, usePermissionCheck, fetch, watcherSaga, };
